export default {
      id: "dislike-usage",
      viewBox: "0 0 8 7",
      url: __webpack_public_path__ + "img/icons.31feac93.svg#dislike",
      toString: function () {
        return this.url;
      }
    }